import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Cloud, CloudRain, CloudSun, MapPin, Sun } from "lucide-react";

import { useTran } from "@/hooks";
import { useWeatherStore } from "../hooks";
import { WEATHER_FALLBACK } from "../stores";

const WeatherCard = observer(() => {
  const { t } = useTran();
  const weatherStore = useWeatherStore();

  useEffect(() => {
    if (weatherStore.status === "idle") {
      weatherStore.fetchWeather();
    }
  }, [weatherStore]);

  const weatherData =
    weatherStore.status === "success" || weatherStore.status === "error"
      ? weatherStore.data
      : null;
  const weatherCondition = weatherData?.condition || t("Loading...");
  const weatherTemp =
    typeof weatherData?.temp === "number" ? weatherData.temp : null;
  const displayLocation = weatherStore.location || WEATHER_FALLBACK.location;
  const isRainy = weatherCondition.toLowerCase().includes("rain");

  const renderWeatherIcon = () => {
    const check = weatherCondition.toLowerCase();
    if (check.includes("rain")) return <CloudRain className="h-5 w-5" />;
    if (check.includes("cloud")) return <CloudSun className="h-5 w-5" />;
    if (check.includes("clear") || check.includes("sun"))
      return <Sun className="h-5 w-5 text-amber-200" />;
    return <Cloud className="h-5 w-5" />;
  };

  return (
    <div className="flex w-full flex-col gap-2 rounded-radius border border-white/15 bg-white/10 px-4 py-3 text-white/80 shadow-sm sm:w-auto">
      <div className="flex items-center gap-2 text-xs font-medium">
        <MapPin className="h-4 w-4" />
        <span>{displayLocation}</span>
      </div>
      <div className="flex items-center gap-3 text-sm font-semibold text-white">
        {renderWeatherIcon()}
        <span>
          {weatherTemp !== null ? `${Math.round(weatherTemp)}°C` : "--"}
          {" · "}
          {weatherCondition}
        </span>
      </div>
      {isRainy ? (
        <span className="text-[11px] text-white/70">
          {t("Don't forget your umbrella!")}
        </span>
      ) : null}
    </div>
  );
});

export default WeatherCard;
